import type { CanvasProjectStyles } from "@/types/canvas"

export type CanvasStylesUnavailableReason = "off" | "empty"

export function canvasHasProjectStyles(styles: CanvasProjectStyles): boolean {
  if (styles.styles_enabled === false) return false
  return Boolean(styles.visual_rendering_style.trim() || styles.genre.trim() || styles.tone.trim())
}

export function canvasProjectStylesUnavailableReason(
  styles: CanvasProjectStyles,
): CanvasStylesUnavailableReason | null {
  if (canvasHasProjectStyles(styles)) return null
  return styles.styles_enabled === false ? "off" : "empty"
}

export function clampCanvasUseProjectStyles(wanted: boolean, styles: CanvasProjectStyles): boolean {
  return wanted && canvasHasProjectStyles(styles)
}
